export const SEARCH_RESULT_BUTTON_CLASS = 'search-result-button';
